module.exports = __webpack_public_path__ + "img/nt50-01a-80-1.prt.ed9f8fd5.jpg";